export default "__VITE_ASSET__dd29b04f__"